<template>
  <reference-filter-multiple-select
    label="Comments"
    :options="options"
    :selected-values.sync="selectedModel"
  />
</template>

<script>
import ReferenceFilterMultipleSelect from './ReferenceFilterMultipleSelect';

const OPTION_VALUE = {
  HAS_COMMENTS: 'HAS_COMMENTS',
  HAS_COMMENTS_BY_YOU: 'HAS_COMMENTS_BY_YOU',
};

const VALUE_TO_LABEL = {
  [OPTION_VALUE.HAS_COMMENTS]: 'Commented on',
  [OPTION_VALUE.HAS_COMMENTS_BY_YOU]: 'Commented on by you',
};

export default {
  name: 'ReferenceFilterComments',
  components: { ReferenceFilterMultipleSelect },
  props: {
    hasComments: {
      type: Boolean,
      default: undefined,
    },
    hasCommentsByYou: {
      type: Boolean,
      default: undefined,
    },
  },
  emits: ['update:hasComments', 'update:hasCommentsByYou'],
  data: () => ({
    options: Object.keys(VALUE_TO_LABEL).map((value) => ({
      value,
      label: VALUE_TO_LABEL[value],
    })),
  }),
  computed: {
    selectedModel: {
      get() {
        const selected = [];
        if (this.hasComments) {
          selected.push(OPTION_VALUE.HAS_COMMENTS);
        }
        if (this.hasCommentsByYou) {
          selected.push(OPTION_VALUE.HAS_COMMENTS_BY_YOU);
        }
        return selected;
      },
      set(value) {
        const hasCommentsValue = this.trueOrUndefined(
          value?.includes(OPTION_VALUE.HAS_COMMENTS)
        );
        const hasCommentsByYouValue = this.trueOrUndefined(
          value?.includes(OPTION_VALUE.HAS_COMMENTS_BY_YOU)
        );
        if (this.hasComments !== hasCommentsValue) {
          this.$emit('update:hasComments', hasCommentsValue);
        }
        if (this.hasCommentsByYou !== hasCommentsByYouValue) {
          this.$emit(
            'update:hasCommentsByYou',
            hasCommentsByYouValue
          );
        }
      },
    },
  },
  methods: {
    trueOrUndefined(value) {
      return value || undefined;
    },
  },
};
</script>
